export default __webpack_public_path__ + "img/pin_icons/fire_door_b.png";